import { Component, OnInit, Input,Output,EventEmitter, SimpleChanges, OnDestroy, Inject, ChangeDetectorRef } from '@angular/core';
import { InvestorService } from '../investor.service'
import { NgForm } from '@angular/forms';
//import { TelemetryService } from '@infosys-it/angular-telemetry-sdk';
import { INTERACTEVENTS, IMPRESSIONEVENTS } from 'app/shared/constants';
import {Appconstants} from '../../../shared/app-constants';
import {ViewportScroller} from '@angular/common'
import {environment} from '../../../../environments/environment.prod';
import { Subject } from 'rxjs';
//import { MatCalendar, DateAdapter, MatDateFormats, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter, MatDateFormats, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { takeUntil } from 'rxjs/operators';
import { MomentDateAdapter } from '@angular/material-moment-adapter';


 import _moment from 'moment';
const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD-MMM-YYYY',
  },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD-MMM-YYYY',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
declare function openconfirmationModel();

@Component({
  selector: 'app-taxforms',
  templateUrl: './taxforms.component.html',
  styleUrls: ['./taxforms.component.css'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class TaxformsComponent implements OnInit {
  @Input() formName: string;
  @Input() selYear: string;
  fileByte: string;
  formData: any = {}; // Initialize formData
  dob_user:any;
  newForm:boolean = false;
  validDob: boolean;
  @Output() onSubmit = new EventEmitter();
  @Output() pageName = new EventEmitter();
  @Output() scrollOnLoad = new EventEmitter();
  strVerifyResponse:object;
  strErrorMessage:string="";
  strSuccessMessage:string="";
  calendarHeader = CalendarHeaderEditProfile;
  document: { documentType: string, documntName: string, fileBytes: string, filename: string } = {
    documentType: "", documntName: "", fileBytes: "", filename: ""
  };
  valFlag: {
    estimatedtotalincome: boolean,

    }= {
    estimatedtotalincome: undefined,
   
  };
  StrErrorMessages: {
    aggregate_amount: string,
    amountofincome: string,
    assessedunder1961act: string,
    estimatedincome: string,
    estimatedtotalincome: string,
    latestassessment_year: string,
    natureofincome: string,
    taxsection: string,
    totalforms_number: string
  } = {
      aggregate_amount: '',
      amountofincome: '',
      assessedunder1961act: '',
      estimatedincome: '',
      estimatedtotalincome: '',
      latestassessment_year: '',
      natureofincome: '',
      taxsection: '',
      totalforms_number: ''
    };
  pageLoad: boolean = true;
  disableSubmit:boolean = true;
  decCheck:boolean=false;
  formDataToSubmit:object={};
  confirmationPopup:boolean=false;
  @Input() cycleFlag:boolean;
  @Input() cycleName:string;
  @Input() windowFlag:boolean;
  UINNumber;
  enableSubmitFlag:boolean=false;
  primaryName:string;
  fullName:string;
  headerData;
  financiarDate:string="";
  headersData:{assessment_year:string,createdby:string,createdby_date:string,cycle_description:string,
  cycle_id:string,cycle_name:string,isactive:string,window_start:string,window_end:string}[]=[];
  blnEnableField: boolean;
  taxregime='';
  isnewtax:boolean=false;
  isoldtax:boolean=false;
  cutoffDate: Date;
  //cutoffDate: Date = new Date(new Date().setFullYear(new Date().getFullYear() - 60));

  // @Input() selYear:string;
  //startDate:Date;
  //private telemetryService:TelemetryService
  //constructor(private telemetryService:TelemetryService,private investorService : InvestorService, private vps : ViewportScroller) { }
  constructor(private investorService : InvestorService, private vps : ViewportScroller) { 
    //dynamic code added as per logic
    const currentYear = new Date().getFullYear();
    const baseYear = 1965; // Starting year for the cutoff
    this.cutoffDate = new Date(`${baseYear + (currentYear - 2025)}-04-01`);
  }

  ngOnInit() {
    //this.startDate= new Date('31-Mar-1945');
   if(environment.telemetryFlg){
     /* let impressionEventData = {
        type: IMPRESSIONEVENTS.FORM,
        pageid: Appconstants.taxFormsPageId,
        uri: window.location.href
      };*/
     // this.telemetryService.impression(impressionEventData);
    }
    this.formData.latestassessment_year = ''; // or any default value 
    console.log(this.formName);

  }


  ngOnChanges(changes: SimpleChanges) {
    for (let property in changes) {
      if (property === 'formName') {
        console.log('Previous:', changes[property].previousValue);
        console.log('Current:', changes[property].currentValue);
      }
    }  
    this.formName = changes['formName'].currentValue;
    this.document.documentType = this.formName;
    this.getHeader();
    this.consentFormChange();
    this.getFormData();
  
    console.log("onChange",this.formName,this.document.documentType);
  }

  onSelectionChange(event: any) {
  //  alert(event.value)
    this.taxregime = event.value;
    this.isnewtax=this.taxregime=="NewTaxRegime"?true:false;
    this.isoldtax=this.taxregime=="OldTaxRegime"?true:false;
   // console.log("taxregime",this.taxregime);
  }
  
 
  getFormData() {
    this.investorService.getForm15(this.formName,this.selYear,this.cycleName).subscribe((data) => {
     //this.taxregime=data['taxregime'];
     
      this.formData = data;
    
      this.pageLoad = false;
      if(this.formName ==='Form 15G'){
        let currentDate = new Date();
        let recordDate = new Date(environment.recordDate);
        if((this.windowFlag || data['enable_submit'].toLowerCase()=="y") && currentDate >= recordDate){
          this.blnEnableField=true;
        }
        else{
          this.blnEnableField=false;
        }
      }
      if(data['enable_submit'].toLowerCase()=="y" && this.windowFlag==false){
        this.windowFlag=true;
      }
      this.scrollOnLoad.emit(true);
      this.UINNumber=this.formData['identification_number'];
      this.primaryName = this.formData['assessee_name'];
      // if(this.formData['taxregime']!=null && this.formData['taxregime']!=''){
      // this.formData['taxregime'] = this.taxregime;    
      // }
      this.fullName=this.primaryName;
      
      let str = this.formData['assessee_name'];
      let strWS = str.replace(' ','');
      if (str.length >= 6) {
        this.primaryName = strWS.substring(0,3) + 'X'.repeat(strWS.length-6) + strWS.substring(strWS.length-3,strWS.length);
      }
      if(this.formData['form_id']==null || this.formData['form_id']==''){
        this.newForm = true;
        this.formData['form_type'] = this.formName;
        this.formData['natureofincome']="Dividend";
        this.formData['taxsection']="194";
        this.formData['amountofincome']=0;
        this.formData['declaration'] = "I hereby provide consent";
        this.dob_user="";
        this.isoldtax=true;
        this.taxregime="NewTaxRegime";
      }
      else{
        this.newForm = false;
        this.valFlag['assessedunder1961act'] = true;
        this.valFlag['taxsection'] = true;
        this.formData['natureofincome']="Dividend";
        this.formData['taxsection']="194";
        this.formData['amountofincome']=0;
        let date= this.formData['dob_user'];
        if(date!="" && date!=null && date!=undefined){
          this.dob_user=moment(this.fnDateInitial(date as any));
        }
        else{
          this.dob_user="";
        }
        console.log("dob",this.dob_user);
        this.isnewtax=this.formData['taxregime'] == "NewTaxRegime"?true:false;
        this.isoldtax=this.formData['taxregime'] =="OldTaxRegime"?true:false;
        this.taxregime=this.formData['taxregime'];
      }
    },
    err => {
      console.log(err);
   
    })
  }

  consentFormChange(){
    this.decCheck=false;
    this.disableSubmit = true;
    this.strErrorMessage="";
   
  }

  confirmation(value:string){
        if(value=='OK'){
          this.confirmationPopup=false;
          this.finalPostModelSubmit();
         }
        else{
          this.confirmationPopup=false;
        }
    }

    fnDateInitial(dateFromModel: string) {
      let formattedDateArray = [];
      let formattedDate: string[];
      let year: number;
      let month: number;
      let date: number;
      if (dateFromModel !== "" && dateFromModel!=null && dateFromModel!=undefined) {
        formattedDate = dateFromModel.split("-");
        if (formattedDate.length > 0) {
          date = Number(formattedDate[0]);
          year = Number(formattedDate[2]);
          month = this.getMonth(formattedDate[1]);
          formattedDateArray = [year, month, date];
        }
      }
      return formattedDateArray
    }
    getHeader(){
      this.investorService.getHeader().subscribe((data)=>{
        console.log('getHeader',data);      
        this.headerData = data;
        this.pageLoad = false;   
      
        for(let i in this.headerData['cycle_details']){
          console.log('loopingheaderdata',this.headerData['cycle_details'][i]);  
          this.headersData.push({assessment_year:this.headerData['cycle_details'][i]['assessment_year'],
          createdby:this.headerData['cycle_details'][i]['createdby'],
          createdby_date:this.headerData['cycle_details'][i]['createdby_date'],
          cycle_description:this.headerData['cycle_details'][i]['cycle_description'],
            cycle_id:this.headerData['cycle_details'][i]['cycle_id'],
            cycle_name:this.headerData['cycle_details'][i]['cycle_name'],
            isactive:this.headerData['cycle_details'][i]['isactive'],
            window_start:this.headerData['cycle_details'][i]['window_start'],
            window_end:this.headerData['cycle_details'][i]['window_end']})
        }     
      
        console.log("this.headersData",this.headersData);      
        console.log(this.headersData.filter(x => x.isactive  === "1")[0]['cycle_name']);
        console.log(this.headersData.filter(x => x.isactive  === "1")[0]['cycle_description']);   
        let dates =this.headersData.filter(x => x.isactive  === "1")[0]['cycle_name'].split("-");
        console.log(dates);  
        let month  = Number (dates[1]) -60;  
  this.financiarDate= month+"-04-01";
  console.log('this.financiarDate',this.financiarDate)
      },
      err => {
        console.log(err);
        this.pageLoad = true;
      })
    }
    
  getMonth(month: string): number {
    let value: number;
    switch (month) {
      case 'Jan': {
        value = 0;
        break;
      }
      case 'Feb': {
        value = 1;
        break;
      }
      case 'Mar': {
        value = 2;
        break;
      }
      case 'Apr': {
        value = 3;
        break;
      }
      case 'May': {
        value = 4;
        break;
      }
      case 'Jun': {
        value = 5;
        break;
      }
      case 'Jul': {
        value = 6;
        break;
      }
      case 'Aug': {
        value = 7;
        break;
      }
      case 'Sep': {
        value = 8;
        break;
      }
      case 'Oct': {
        value = 9
        break;
      }
      case 'Nov': {
        value = 10
        break;
      }
      case 'Dec': {
        value = 11
        break;
      }
    }
    return value;
  }

  convertFileToByte(file: File) {
    var fileReader: FileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onloadend = (e) => {
      console.log(e);
      this.fileByte = fileReader.result as string;
      this.fileByte = this.fileByte.split(',')[1];
      this.document.fileBytes = this.fileByte;
      this.document.filename = file.name;
      console.log("totalfiles", this.fileByte);
    };
  }

  validateType(type,name) {
    // let accept = ['application/msword', 'application/vnd.ms-excel', 'application/vnd.ms-powerpoint',
    //   'text/plain',' application/pdf', 'image/*'];
    // .xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf
    // let re =/(\.pdf|\.doc|\.docx|\.ppt|\.pptx|\.txt|\.xlsx|\.xls)$/
    let re =/(\.pdf)$/

    if( type.match('image/*')){
      return true;
    }
    else if(re.exec(name)){
      return true;
    }
    else {
      return false;
    }
  }

  attachFile(target) {
    console.log("target", target['files']);
    if (this.validateType(target['files'][0]['type'],target['files'][0]['name'])) {
      this.convertFileToByte(target['files'][0]);
    }
    else {
      console.log("invalid file");
      this.document['fileBytes'] = '';
      this.document['filename'] = '';
    }
  }
  
  
  checkConsent(event){
    if(event.target.checked){
      this.decCheck=true;
      console.log("incheck");
       this.disableSubmit = false;
    }
    else{
      this.decCheck=false;
      console.log("not check");
      this.disableSubmit = true;
      
    }
  }

  fnTakeAction(form: NgForm) {
   // alert ("in take action"+this.taxregime);
    let dobSubmit: string;
    let arrFromDate: string[] = [];
    let strfinalDOB: string;
    let totalincome:number=1200000;
    let aggreggate:number=400000;
    // this.formData['estimatedincome']!=null&&this.formData['estimatedincome']!=''?this.valFlag.estimatedincome=true:this.valFlag.estimatedincome=false;
    
    //  if(this.formData['estimatedincome']!=null&&this.formData['estimatedincome']!=''){
        
    //    if(this.formData['estimatedincome']<0 ){
    //       this.strErrorMessage = "Estimated income should be greater than zero";
    //       return;
    //    }
    //     if((this.formData['dividend_amt']+this.formData['prev_dividend_amt'])>250000  && this.formName == "Form 15G"){
    //         this.strErrorMessage = "Estimated income should not exceed 2,50,000.";
    //         return;
    //     }
     
     
    //   }
    if(this.taxregime == 'OldTaxRegime'){
      totalincome = 500000;
      aggreggate= 250000;
    }

    this.formData['estimatedincome']=(this.formData['dividend_amt']+this.formData['prev_dividend_amt'])>250000?250000:(this.formData['dividend_amt']+this.formData['prev_dividend_amt']);

      
    this.formData['estimatedtotalincome']!=null&&this.formData['estimatedtotalincome']!=''?this.valFlag.estimatedtotalincome=true:this.valFlag.estimatedtotalincome=false;
   // this.formData['estimatedtotalincome']>0 ?this.valFlag.estimatedtotalincomeNegative=true:this.valFlag.estimatedmincomeNegative=false;

    if(this.formData['estimatedtotalincome']!=null&&this.formData['estimatedtotalincome']!=''){
      if(this.formData['estimatedtotalincome']<0)
      {
        this.strErrorMessage = "Estimated Total income should be greater than zero.";
        return;
      }
      if(this.formData['estimatedtotalincome']>totalincome && this.formData['estimatedtotalincome']!= totalincome){    
        this.strErrorMessage = "Estimated Total income should not exceed "+totalincome.toLocaleString('en-IN')+".";
          return;
      }
    }
    
    if(this.formName == "Form 15G"){
      if((this.formData['aggregate_amount']) > aggreggate && (this.formData['aggregate_amount']) != aggreggate ){
        this.strErrorMessage = "Estimated income and Aggregate income should not exceed "+aggreggate.toLocaleString('en-IN')+".";
        return;
      }
    }
    
    this.strErrorMessage="";

    const flagarray = Object.keys(this.valFlag);
    
    console.log("flag",flagarray);

    let flg = true;
    flagarray.map(flag=>{
      flg = flg&&this.valFlag[flag];
    })
    if(!flg){
      this.strErrorMessage = "Please fill all the required fields.";
      return;
    }
   
    if(this.formName == "Form 15H" ){
      //this.checkDob(form.value['dob_user']); 
      console.log(form.value['dob_user']);
      if(form.value['dob_user']=="" || form.value['dob_user']==null || form.value['dob_user']==undefined)
      {
      this.validDob = false;
      this.strErrorMessage = "Please enter date of birth.";
      return;
      }
    }
   
    const allowed = ['aggregate_amount',
    'dividend_amt',
    'amountofincome',
    'assessedunder1961act',
    'assessee_name',
    'declaration',
    'estimatedincome',
    'estimatedtotalincome',
    'form_id',
    'form_type',
    'identification_number',
    'latestassessment_year',
    'natureofincome',
    'previousyear',
    'status_user',
    'taxsection',
    'totalforms_number',
    'dob_user',
    'taxregime'
  ];


    this.formDataToSubmit = Object.keys(this.formData)
      .filter(key => allowed.indexOf(key)!=-1)
      .reduce((obj, key) => {
        obj[key] = this.formData[key];
        return obj;
      }, {});

      if(this.formName == "Form 15H" ){
        let dobSubmit=form.value['dob_user']['_d'];
        arrFromDate =  dobSubmit.toString().split(" ");
        strfinalDOB = arrFromDate[2] + '-' + arrFromDate[1] + '-' + arrFromDate[3];
        this.formDataToSubmit['dob_user']= strfinalDOB;
      }
      this.formDataToSubmit['taxregime'] = this.taxregime;
      console.log("formDataToSubmitafter", this.formDataToSubmit);

    if(this.newForm==false){
      this.confirmationPopup=true;
      openconfirmationModel();
      
    }
     else{
      this.finalPostModelSubmit();
     }
   

    
  }

  finalPostModelSubmit(){
    this.pageLoad =true;
    console.log("emiitt");
    this.investorService.uploadForm(this.formDataToSubmit).subscribe(data => {
      this.strVerifyResponse= data as object;
      console.log("output",  this.strVerifyResponse);
      if (this.strVerifyResponse['code'] == "1") {
        this.pageLoad = false;     
        this.strSuccessMessage = this.strVerifyResponse['message'];
         this.pageName.emit('RESIDENT');  
        if(environment.telemetryFlg){
        let telemetryEventData = {
          type: INTERACTEVENTS.CLICK,
          id: this.formName +" "+ Appconstants.success,
          pageid: Appconstants.taxFormsPageId
        }
        //this.telemetryService.interact(telemetryEventData);
     }
        //this.strSuccessMessage = this.strVerifyResponse['message'];
        this.strErrorMessage = '';
        //this.pageLoad = false;
       // this.pageName.emit('RESIDENT');
      }
      else{
        this.strErrorMessage=this.strVerifyResponse['message'];
        this.pageLoad = false;
        if(environment.telemetryFlg){
          let telemetryEventData = {
            type: INTERACTEVENTS.CLICK,
            id: Appconstants.submit + " " + Appconstants.error +" "+ this.strErrorMessage ,
            pageid: Appconstants.taxFormsPageId
          }
        //  this.telemetryService.interact(telemetryEventData);
      }

         setTimeout(() => {
          this.strErrorMessage = "";
          }, 3000);
      }
    },err=>{
      console.log(err);
      this.strErrorMessage="Some Error Occured, Please try later.";
      this.pageLoad = false;
        if(environment.telemetryFlg){
          let telemetryEventData = {
            type: INTERACTEVENTS.CLICK,
            id: Appconstants.submit + " " + Appconstants.failure +" "+ err ,
            pageid: Appconstants.taxFormsPageId
          }
        //  this.telemetryService.interact(telemetryEventData);
      }
      setTimeout(() => {
        this.strErrorMessage = "";
        }, 3000);
     
    });
  }

  // checkDob(dob: Date) {
  //   console.log("checkDob", dob);
  //   var entereddate= new Date(dob).toLocaleString();
  //   var finalDate=  this.fnDateConversion(entereddate);
  //   if(new Date(finalDate) <= new Date('3-31-1961') || new Date(finalDate) <= new Date('31-Mar-1961')){
  //     this.validDob = true;
  //   }
  //   else {
  //     this.validDob = false;
  //   }


  // }

  fnDateConversion(planDate:string){
    var dateSplit= planDate.split(',');
    var datePart= dateSplit[0].split('/');
    return datePart[0]+"-"+datePart[1]+"-"+datePart[2];
   
  
  }

  scroll(id) {
    this.vps.scrollToAnchor(id)
  }

  reset(){
    this.getFormData();
  }
}



@Component({
  selector: 'calendar-header',
  styles: [`
    .calendar-header {
      display: flex;
      align-items: center;
      padding: 0.5em;
    }

    .calendar-header-label {
      flex: 1;
      height: 1em;
      font-weight: 500;
      text-align: center;
    }

    .calendar-double-arrow .mat-icon {
      margin: -22%;
    }
  `],
  template: `
    <div class="calendar-header">
      <button mat-icon-button class="calendar-double-arrow" (click)="previousClicked('year')">
        <mat-icon>keyboard_arrow_left</mat-icon>
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button mat-icon-button (click)="previousClicked('month')">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <span class="calendar-header-label">{{periodLabel}}</span>
      <button mat-icon-button (click)="nextClicked('month')">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
      <button mat-icon-button class="calendar-double-arrow" (click)="nextClicked('year')">
        <mat-icon>keyboard_arrow_right</mat-icon>
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  `,
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarHeaderEditProfile<D> implements OnDestroy {
  private _destroyed = new Subject<void>();

  constructor(
    private _calendar: MatCalendar<D>, private _dateAdapter: DateAdapter<D>,
    @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats, cdr: ChangeDetectorRef) {
    _calendar.stateChanges
      .pipe(takeUntil(this._destroyed))
      .subscribe(() => cdr.markForCheck());
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  get periodLabel() {
    return this._dateAdapter
      .format(this._calendar.activeDate, this._dateFormats.display.monthYearLabel)
      .toLocaleUpperCase();
  }

  previousClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
      this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1) :
      this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
  }

  nextClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
      this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1) :
      this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
  }

}
